export default "__VITE_ASSET__BHvlphoA__"